import { render, staticRenderFns } from "./IconGlobeSolid.vue?vue&type=template&id=2656acb4"
import script from "./IconGlobeSolid.vue?vue&type=script&lang=js"
export * from "./IconGlobeSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports